<template>
  <path
    fill-rule="nonzero"
    d="M9 17C-8.558 6.892 4.14-5.676 9 2.788 13.86-5.676 26.56 6.892 9 17z"
  />
</template>

<script>
export default {}
</script>

<style></style>



// WEBPACK FOOTER //
// components/_SVG/HeartIcon.vue